/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-08T17:39:58.814
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listContractSubjectAcount,
	listContractSubjectAcountInit,
	listContractSubjectAcountByAuthorizations,
	deleteContractSubjectAcount
} from '@api/storagemanage/ContractSubjectAcount';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listContractSubjectAcount({
			state
		}) {
			return new Promise((resolve, reject) => {
				listContractSubjectAcount(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listContractSubjectAcountByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listContractSubjectAcountByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listContractSubjectAcountInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listContractSubjectAcountInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteContractSubjectAcount({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteContractSubjectAcount({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
